"use client";

import { useEffect } from "react";

/**
 * Route-level error boundary. Caught errors inside `app/` (that don't
 * escape to the root) render this UI instead of a blank page. We log
 * the full error to the console so production source-mapped traces
 * still show up for debugging.
 */
export default function RouteError({ error, reset }) {
  useEffect(() => {
    // eslint-disable-next-line no-console
    console.error("[route error]", error);
  }, [error]);

  return (
    <main
      style={{
        minHeight: "60vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "1rem",
        padding: "2rem",
        textAlign: "center",
        color: "#1d1d1f",
      }}
    >
      <h1 style={{ fontSize: "clamp(1.5rem, 3vw, 2rem)", margin: 0 }}>
        Something went wrong.
      </h1>
      <p style={{ maxWidth: 480, margin: 0, opacity: 0.7 }}>
        We hit an unexpected issue rendering this page. The error has been
        logged — try again, or head back home.
      </p>
      <div style={{ display: "flex", gap: "0.75rem", marginTop: "0.5rem" }}>
        <button
          type="button"
          onClick={() => reset()}
          style={{
            padding: "0.7rem 1.25rem",
            borderRadius: 999,
            border: "1px solid rgba(0,0,0,0.12)",
            background: "#1d1d1f",
            color: "#fff",
            cursor: "pointer",
          }}
        >
          Try again
        </button>
        <a
          href="/"
          style={{
            padding: "0.7rem 1.25rem",
            borderRadius: 999,
            border: "1px solid rgba(0,0,0,0.12)",
            background: "transparent",
            color: "#1d1d1f",
            textDecoration: "none",
          }}
        >
          Back to home
        </a>
      </div>
    </main>
  );
}
